const MuiInputLabel = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.grey[600]
            }),
        sizeSmall: {
            top: '-3px'
        },
        shrink: {
            top: '0px'
        }
    }
};
export { MuiInputLabel };

//# sourceMappingURL=input-label.js.map